import { NoticeModify } from './NoticeModify';

export default NoticeModify;
